/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Limits_BodyInputs */

const en_svc_rag_limits_body = /** @type {(inputs: Svc_Rag_Limits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A knowledge base is only as current as the documents behind it, so we design for the gaps.`)
};

const lv_svc_rag_limits_body = /** @type {(inputs: Svc_Rag_Limits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zināšanu bāze ir tik aktuāla, cik aktuāli ir tās dokumenti. Tāpēc paredzam arī rīcību, ja informācijas trūkst.`)
};

/**
* | output |
* | --- |
* | "A knowledge base is only as current as the documents behind it, so we design for the gaps." |
*
* @param {Svc_Rag_Limits_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_limits_body = /** @type {((inputs?: Svc_Rag_Limits_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Limits_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_limits_body(inputs)
	return en_svc_rag_limits_body(inputs)
});